export default "__VITE_ASSET__CqMCHV9I__"